const getDirectionsStep = require("./directionsstep");
const utils = require("../utils");

/**
 * Gets leg implementation.
 * @private
 * @param {|google.maps.DirectionsLeg} leg leg or array of steps depending on the current loaded library (Google/Baidu)
 * @param {Number} duration
 * @returns {BaiduDirectionsLeg|google.maps.DirectionsLeg}
 */
function getDirectionsLeg(leg, duration = null) {
    return leg;
}

module.exports = getDirectionsLeg;
